import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AppBar } from '@material-ui/core';
import { svg, colors, components } from '@peachjar/components';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { css, cx } from 'react-emotion';
import ToolBar from './components/ToolBar';

const {
  Notifications: { NotificationContainer },
} = components;
const { silver, white } = colors;
/* 

TECH DEBT (DEV-2320): Creat a sharable brand Bar component - to include test and flow types ability to give developer a good api to use

*/

export const PeachjarBrandBar = ({
  isAuthenticated,
  classes,
  logout,
  login,
  email,
  image,
}) => (
  <div className={classes.root}>
    <AppBar classes={{ root: classes.appbar }} color="inherit">
      <NotificationContainer />

      <ToolBar
        isAuthenticated={isAuthenticated}
        login={login}
        logout={logout}
        email={email}
        image={image}
      />
    </AppBar>
  </div>
);
const styles = {
  root: {
    flexGrow: 1,
  },
  appbar: {
    height: '83px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: `${white}`,
    borderBottom: `solid 2px ${silver}`,
    padding: '0 1.875em',
    boxShadow: 'none',
  },
};

const mapStateToProps = state => ({
  isAuthenticated: state.user.isAuthenticated,
  email: state.user.email,
  image: state.user.image,
});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch({ type: 'auth/INITIATE_LOGOUT' }),
  login: () => dispatch({ type: 'auth/INITIATE_LOGIN' }),
});

const BrandBarWithStyles = withStyles(styles)(PeachjarBrandBar);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BrandBarWithStyles);



// WEBPACK FOOTER //
// ./src/_app/components/BrandBar/BrandBar.jsx